export default function (props: any) {
    return (
        <svg
            width="43px"
            height="40px"
            viewBox="0 0 43 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="-M端-Smart-Generator-(Dual-Fuel)" transform="translate(-250.000000, -3714.000000)">
                    <g id="编组-11" transform="translate(250.000000, 3714.000000)">
                        <path
                            d="M15.1341218,22.6668345 L25.5629997,28.8290497 L23.7976914,32.5997016 L28.5751891,40 L19.2337488,34.3516721 L21.6225385,30.960329 L15.1341218,22.6668345 Z M28.5751891,0 L23.7976914,7.40029836 L25.5629997,11.1709503 L15.1341218,17.3331655 L21.6225385,9.03967104 L19.2337488,5.64832787 L28.5751891,0 Z"
                            id="形状结合"
                            fill="#FF0060"
                        ></path>
                        <path
                            d="M2.21977553,28.0585358 C0.993827358,28.0585358 0,27.0877907 0,25.8903158 L0,13.4230508 C0,12.2255759 0.993827358,11.2548308 2.21977553,11.2548308 L6.38185466,11.2548308 L13.2021688,5.11886236 C14.103909,4.30760219 15.5082078,4.36397273 16.3387579,5.24476949 C16.7162414,5.64508996 16.9257884,6.16943591 16.9257884,6.71368597 L16.9257884,32.5996806 C16.9257884,33.7971554 15.9319611,34.7679006 14.7060129,34.7679006 C14.1488218,34.7679006 13.612008,34.5632204 13.2021688,34.1945042 L6.38185466,28.0585358 L2.21977553,28.0585358 Z"
                            id="路径"
                            fill="#FF0060"
                        ></path>
                        <rect id="矩形备份-4" fillOpacity="0.2" fill="#FF0060" x="34.0416667" y="13.6363636" width="8.95833333" height="2.72727273"></rect>
                        <rect id="矩形备份-15" fillOpacity="0.2" fill="#FF0060" x="34.0416667" y="8.18181818" width="8.95833333" height="2.72727273"></rect>
                        <rect id="矩形备份-5" fillOpacity="0.2" fill="#FF0060" x="34.0416667" y="19.0909091" width="8.95833333" height="2.72727273"></rect>
                        <rect id="矩形备份-6" fill="#FF0060" x="34.0416667" y="24.5454545" width="8.95833333" height="2.72727273"></rect>
                        <rect id="矩形备份-14" fill="#FF0060" x="34.0416667" y="30" width="8.95833333" height="2.72727273"></rect>
                        <g id="编组-34" transform="translate(34.041667, 8.181818)"></g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
